<template>
  <div class="show_pro">
    <div v-html="src"></div>
  </div>
</template>

<script>
export default {
  props: ['src']
}
</script>

<style scoped lang="less">
.show_pro {
  width: 90%;
  margin-left: 5%;
  background: #fff;
}
</style>
